export function useProductoTitle(oper, producto) {
    if (oper === "add") {
        return "Agregar " + producto;
    }
    if (oper === "edit") {
        return "Editar " + producto;
    }
    if (oper === "view") {
        return "Ver " + producto;
    }
}
